/* Parallaxe du bandeau « la marque » : le contenu derive dans le bandeau au defilement.
   Sorti du <script> inline de la section (non mis en cache, non minifie). */
(() => {
  const init = (contenu) => {
    if (contenu.dataset.mmParallaxPret === '1') return;
    const banniere = contenu.closest('[data-section-id]')?.querySelector('.mm-marque-parallax-banner');
    if (!banniere) return;
    contenu.dataset.mmParallaxPret = '1';

    /* Aucune media query ici : le CSS decide seul ou la parallaxe s'applique, via
       la regle `transform`. La dupliquer en JS creait une seconde source de
       verite, et c'est elle qui empechait l'effet en mobile alors que la mise en
       page « bandeau seul » sait tres bien l'accueillir. */
    const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = null;

    const update = () => {
      frame = null;
      if (mouvementReduit.matches) {
        contenu.style.removeProperty('--mm-parallax-y');
        return;
      }
      const rect = banniere.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      /* La course se DEDUIT du jeu reellement laisse par le CSS sous le contenu, jamais
         de la variable de reglage : celle-ci est bornee differemment en mobile, et une
         valeur bornee par `min()` ne se relit pas en nombre depuis une propriete
         personnalisee. La geometrie, elle, est deja resolue par le navigateur a chaque
         largeur. Depasser ce jeu ferait sortir le mot du bandeau, que `overflow: hidden`
         couperait. */
      const course = Math.max(0, banniere.clientHeight - contenu.offsetHeight);
      /* Progression du bandeau dans la fenetre : 0 quand son haut affleure le bas de
         l'ecran, 1 quand son bas le quitte par le haut. Le contenu parcourt la course sur
         ce trajet, donc il avance moins vite que la page — c'est la parallaxe.
         L'ancienne formule, `(vh - hauteurContenu) / 2 - rect.top`, annulait EXACTEMENT le
         defilement : le mot restait fige a 98 px du haut sur toute la traversee (mesure du
         02/09/2026, sept positions de scroll), ce qui se lit comme une page qui n'avance
         plus. Ce n'etait pas une parallaxe, c'etait un epinglage. */
      const progression = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      /* Propriete personnalisee et non `style.transform` : le decalage reste une DONNEE, la
         regle `transform` reste dans le CSS, donc la media query mobile peut l'ecraser
         normalement au lieu d'avoir a battre un style inline. */
      contenu.style.setProperty('--mm-parallax-y', `${progression * course}px`);
    };
    const demander = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
    if (mouvementReduit.addEventListener) mouvementReduit.addEventListener('change', demander);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(demander);
  };

  const boot = (scope) => scope.querySelectorAll('[data-mm-parallax-content]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
